import styles from './Chip.module.css';

interface ChipProps {
  children: React.ReactNode;
  className?: string;
}

export function Chip({ children, className = '' }: ChipProps) {
  return <span className={`${styles.chip} ${className}`}>{children}</span>;
}
